import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/index'
import Home from '@/pages/home/home'
import Test from '@/pages/page-one/test'
import Timu from '@/pages/timu/timu'
import Change from '@/pages/change/change'
import Photo from '@/pages/photo/photo'
import End from '@/pages/end/end'




// import Report from '@/page/report'
// import Service from '@/page/service'
// import News from '@/page/news'
// import NewsInfo from '@/page/newsInfo'
// import Form from '@/page/form'
// import Start from '@/page/start'
// import Notice from '@/page/notice'
// import Notices from '@/page/notices'
// import Services from '@/page/services'


Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
    },{
      path: '/test',
      name: 'test',
      component: Test,
    },{
      path: '/timu',
      name: 'timu',
      component: Timu,
    },{
      path: '/change',
      name: 'change',
      component: Change,
    },{
      path: '/photo',
      name: 'photo',
      component: Photo,
    },{
      path: '/end',
      name: 'end',
      component: End,
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js